/**
 * AddPackageCtrl controller
 * Add/edit package
 */

AddPackageCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * AddPackageCtrl controller
 *
 * @class AddPackageCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddPackageCtrl
 */
/* @ngInject */
export default function AddPackageCtrl (
  $sce,
  $http,
  $location,
  $q,
  $scope,
  $uibModal,
  Ecwid,
  InappSettings,
  Network,
  NetworkSetting,
  TemplateVariable,
  alertLiteSvc,
  alertSvc,
  apiAccess,
  authSvc,
  ecwid,
  generalSettings,
  inapp,
  pckg,
  templateVariables
) {
  const vm = this
  // Tooltip for strong password policy (HTML list, used in addPackage.html)
  vm.strongPwdTooltip = $sce.trustAsHtml(
    '<div style="padding: 12px">' +
    '<div>Subscriber’s password must comply with the following security requirements:</div>' +
    '<ul style="margin:6px 0 0 18px;padding:0;">' +
      '<li>Min 8 symbols</li>' +
      '<li>At least one uppercase and lowercase Latin letter</li>' +
      '<li>At least one digit (0–9)</li>' +
      '<li>At least one symbol (@#$_&-*!?.)</li>' +
    '</ul>' +
    '</div>'
  )

  // Tooltip for default password policy (two lines)
  vm.defaultPwdTooltip = $sce.trustAsHtml(
    '<div style="padding: 12px">' +
    '<div>Subscriber’s password must comply with the following security requirements:</div>' +
    '<ul style="margin:6px 0 0 18px;padding:0;">' +
    '<li>Min 6 symbols</li>' +
    '<li>Only Latin letters, numbers (0-9) and symbols (@#$_&-*!?.)</li>' +
    '</ul>' +
    '</div>'
  )

  vm.templateVariables = templateVariables
  const baseMixes = ['tabsCtrlMixin', 'general_settings']
  if (pckg.id) {
    const mixesWithPckg = [...baseMixes, 'organization_settings', 'template_variables']
    const hasSetrixAccess = authSvc.hasAccess('viewSetrixSettings')
    vm.mixes = pckg.multiorgEnabled && authSvc.hasAccess('viewMultiorgSettings')
      ? authSvc.hasEnabledFlag('CHAT_ENABLED')
        ? [[...mixesWithPckg, 'activation_settings', 'chat_settings', ...(hasSetrixAccess ? ['setrix_server_settings'] : [])]]
        : [[...mixesWithPckg, 'activation_settings', ...(hasSetrixAccess ? ['setrix_server_settings'] : [])]]
      : [[...mixesWithPckg]]
  } else {
    vm.mixes = [[...baseMixes]]
  }

  vm.showMultitenantTabs = !!(pckg?.id && pckg?.multiorgEnabled && authSvc.hasAccess('viewMultiorgSettings'))
  if ($scope) {
    $scope.showMultitenantTabs = vm.showMultitenantTabs
  }

  vm.showSetrixTab = function () {
    return vm.pckg.id &&
      authSvc.hasEnabledFlag('FEATURE_SETRIX_INTEGRATION_ENABLED') &&
    vm.pckg.multiorgEnabled &&
    authSvc.hasAccess('viewSetrixSettings')
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Has access channel constant
   *
   * @memberOf mwApp/packages.controller:AddPackageCtrl
   * @function
   */
  vm.hasAccess = function (access) { return authSvc.hasAccess(access) }

  vm.hasEditNetworkGeneral = authSvc.hasAccess('editNetworkGeneral')

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  if (authSvc.hasEnabledFlag('ECOMMERCE_PROVIDER_ENABLED')) {
    vm.pckg.$ecwidEnabled = ecwid ? !!ecwid.enabled : false
    vm.pckg.$ecwidSettings = ecwid ? new Ecwid({
      ...ecwid,
      networkId: vm.pckg.id
    }) : new Ecwid({ networkId: vm.pckg.id })
  }

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  /**
   * @memberof mwApp/packages.controller:AddPackageCtrl
   *
   * @param id
   * @returns {false|string}
   */
  vm.isInappNetwork = vm.pckg.id === vm.inappNetworkId && 'inapp'
  /**
   * @memberof mwApp/packages.controller:AddPackageCtrl
   *
   * @param id
   * @returns {false|string}
   */
  vm.isGuestNetwork = vm.pckg.id === vm.guestNetworkId && 'guest'
  /**
   * Info message for ask to delete subscription
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   *
   */
  vm.removeDefaultNetworkMessage = {
    both: 'This Organization is a default Organization for Guest Mode and for In-App Registration. To remove it You should change Guest Mode and In-App Registration settings.<br><br>Do You want to change Guest mode and In-App Registration setting?',
    inapp: 'This Organization is a default Organization for In-app registration. To remove it You should change In-app registrations settings.<br><br>Do You want to change In-app registrations setting?',
    guest: 'This Organization is a default Organization for Guest Mode. To remove it You should change Guest Mode settings.<br><br>Do You want to change Guest mode setting?'
  }[vm.isInappNetwork && vm.isGuestNetwork ? 'both' : (vm.isInappNetwork || vm.isGuestNetwork)]

  vm.messageForRemovingNetworkWithoutGeneralPermissions = 'This Organization is a default Organization for In-app registration/Guest mode.<br>To remove it You should contact your administrator <br>to change In-app registrations/Guest mode settings.'
  /**
   * @memberof mwApp/packages.controller:AddPackageCtrl
   *
   *  redirection to 'generalsettings'
   */
  vm.redirectToSettings = function () {
    $location.url('generalsettings')
  }

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   * @type {Boolean}
   */
  vm.isNew = pckg._isNew()

  if (!vm.isNew && authSvc.hasAccess('viewAPIAccess')) {
    vm.pckg.apiAccessUser = {
      enabled: apiAccess.apiAccessEnabled,
      login: apiAccess.login,
      token: apiAccess.token
    }
    vm.showSimpleCheckbox = !vm.pckg.apiAccessUser.enabled
  } else {
    vm.pckg.apiAccessUser = null
    vm.showSimpleCheckbox = true
  }

  /**
   * Platforms array
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   * @type {Object[]}
   */
  vm.platforms = pckg._enhancePlatforms(['STB']) // default value for new package is 'STB'

  /**
   * Checkbox if prefix is autogenerated
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   * @type {Boolean}
   */
  vm.autoPrefix = !vm.pckg.prefix

  /**
   * Check, if at least one platform is selected
   * @return {Boolean}
   */
  vm.atLeastOnePlatform = function () {
    for (var i = vm.platforms.length; i--;) {
      if (vm.platforms[i].checked) {
        return true
      }
    }
    return false
  }

  if (authSvc.hasEnabledFlag('ECOMMERCE_PROVIDER_ENABLED') && !vm.isNew) {
    Network.loadAllowedCurrencies(vm.pckg.id).then((result) => {
      vm.allowedCurrencies = angular.copy(result.data.currenciesAllowedForNetwork)
      if (vm.pckg.$ecwidSettings.currency) {
        vm.pckg.$ecwidSettings.currency = vm.allowedCurrencies.find((currency) => currency.id === vm.pckg.$ecwidSettings.currency.id)
      }
    }).catch(() => {
      vm.allowedCurrencies = []
    })
  }

  /**
   * Base upload method
   *
   * @param file
   * @param {Object} params
   * @returns {Promise}
   */
  function upload (file, params) {
    return pckg._uploadFileNetwork(file, params)
  }

  /**
   * Upload package logo
   *
   * @memberOf mwApp/channels.controller:StbSettingsCtrl
   * @function
   */
  vm.uploadPackageLogo = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope && $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width < 500 || this.height < 294) {
        alertLiteSvc.alertError('Organization Logo is less than minimum size: 500x294')
        $scope && $scope.$broadcast('dndfile.clear', true)
        return
      }
      return upload(file, {
        logo: 'Nora'
      }).then((response) => {
        pckg.logoUrl = response.data.resourceUrl
      }).finally(() => {
        vm.unsetDisable()
        $scope && $scope.$broadcast('dndfile.clear', true)
      })
    }
    img.src = objectUrl
    vm.form.$setDirty()
  }

  vm.deleteLogo = function () {
    vm.form.$setDirty()
    vm.pckg.logoUrl = null
  }

  /**
   * Create or edit package/network
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   */
  vm.save = function () {
    const promises = []
    vm.setDisable()
    if (authSvc.hasEnabledFlag('ECOMMERCE_PROVIDER_ENABLED') && !vm.isNew) {
      if (vm.pckg.$ecwidEnabled) {
        pckg.$ecwidSettings.networkId = pckg.id
        pckg.$ecwidSettings.enabled = true
        const ecwidSave = pckg.$ecwidSettings._save(null, null, null, null)
        promises.push(ecwidSave)
      } else if (pckg.$ecwidSettings.id) {
        pckg.$ecwidSettings.networkId = pckg.id
        pckg.$ecwidSettings.enabled = false
        const ecwidSave = pckg.$ecwidSettings._save(null, null, null, null)
        promises.push(ecwidSave)
      }
    }
    const pckgSave = pckg._reducePlatforms(vm.platforms)
      ._save(pckg => { pckg.prefix = pckg.prefix && !vm.autoPrefix ? pckg.prefix.toUpperCase() : null }, null, null, null)
    promises.push(pckgSave)
    Promise.all(promises)
      .then(() => {
        alertLiteSvc.alert(`Organization ${pckg.name} is ${vm.isNew ? 'saved' : 'updated'}`, 'success')
        vm.location(pckg).reload()
      })
      .catch((rejection) => alertLiteSvc.alertError(rejection?.statusText || rejection))
      .finally(vm.unsetDisable)
  }

  /**
   * Delete package/network
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   */
  vm.delete = function () {
    vm.setDisable()

    pckg._delete(`The Organization "${pckg.name}" removal process has started`)
      .then(vm.location(pckg).list)
      .catch((rejection) => alertLiteSvc.alertError(rejection?.statusText || rejection))
      .finally(vm.unsetDisable)
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Clone package/network
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   */
  vm.duplicate = function () {
    vm.setDisable()

    pckg._duplicate()
      .catch((rejection) => alertLiteSvc.alertError(rejection?.statusText || rejection))
      .finally(vm.unsetDisable)
  }

  /**
   * Info message for deleting package
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   *
   * @return {string}
   */
  vm.removeSubMessage = function () {
    if (vm.pckg.id !== vm.inappNetworkId) {
      return ''
    }
    return `<br><br><small>NOTE: ${vm.guestNetworkId ? 'Guest Mode' : ''}${vm.guestNetworkId && vm.inappNetworkId ? '/' : ''}${vm.inappNetworkId ? 'In-app Registration' : ''} for "${vm.pckg.name}" will be disabled before you select other Organization for ${vm.guestNetworkId ? 'Guest Mode' : ''}${vm.guestNetworkId && vm.inappNetworkId ? '/' : ''}${vm.inappNetworkId ? 'In-app Registration' : ''}</small>`
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicListUrl)
    }
  }

  vm.randomizeLogin = function () {
    vm.form.$setDirty()
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_'
    const charactersLength = characters.length
    let counter = 0
    while (counter < 17) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
      counter += 1
    }
    vm.pckg.apiAccessUser.login = result
  }

  vm.copyString = function (model, text = '') {
    navigator.clipboard.writeText(model)
    alertLiteSvc.alert('Copied ' + text + ': ' + model, 'success')
  }

  vm.changeApiAccessEnabled = function () {
    vm.showSimpleCheckbox = vm.pckg.apiAccessUser && !vm.pckg.apiAccessUser.enabled
  }

  /********************************/
  /* === Organization Setting === */
  /********************************/
  vm.APP_DEVICE_LINK_CODE_ENABLED = !!window.ENV.APP_DEVICE_LINK_CODE_ENABLED

  // If the app runs locally (developer machine), force opening Setrix tab first.
  // Uses hostname detection to avoid relying on ENV injection.
  const hostname = window.location && window.location.hostname ? window.location.hostname : ''
  const isLocalLaunch = hostname === 'localhost'

  if (isLocalLaunch && vm.showSetrixTab()) {
    $location.hash('setrix_server_settings')
  }

  function prepareSettings () {
    // save settings in order to compare later what was changed
    vm.originals = angular.copy(vm.networkSettings)
    vm.paymentVoidEnabled = (vm.networkSettings.PAYMENT_VOID_HOURS.useSystemDefault ? generalSettings : vm.networkSettings).PAYMENT_VOID_HOURS.value !== 0
  }

  vm.pckg.id && NetworkSetting.loadAll({ network: pckg })
    .to(vm.networkSettings = {})
    .then(prepareSettings)
    .then(() => {
      vm.networkSettings = angular.copy(vm.networkSettings)
      for (const setting in vm.networkSettings) {
        vm.changeSetting(setting)
      }
      vm.networkSettings.UNLIMITED_SUBSCRIPTION_ENABLED.useSystemDefault = vm.networkSettings.ACTIVATION_LENGTH_LIMIT.useSystemDefault
      vm.networkSettings.UNLIMITED_SUBSCRIPTION_ENABLED.useSystemDefault = vm.networkSettings.ACTIVATION_LENGTH_LIMIT.useSystemDefault
      // MW-12853: default the per-org Address Validation Service setting to Allow when the
      // backend doesn't return it yet (BE side of MW-12594 pending). Seed both the working
      // copy and the originals snapshot so it isn't sent to the backend unless the user
      // actually changes it. When the BE provides the key, its value is used instead.
      if (!vm.networkSettings.ADDRESS_VALIDATION_SERVICE_ENABLED) {
        const addressValidationDefault = { name: 'ADDRESS_VALIDATION_SERVICE_ENABLED', value: true, useSystemDefault: false }
        vm.networkSettings.ADDRESS_VALIDATION_SERVICE_ENABLED = angular.copy(addressValidationDefault)
        vm.originals.ADDRESS_VALIDATION_SERVICE_ENABLED = angular.copy(addressValidationDefault)
      }
      const offlineDefaults = [
        { name: 'OFFLINE_PLAYBACK_MAX_COUNT', value: 20 },
        { name: 'OFFLINE_PLAYBACK_MAX_QUALITY', value: 'HD' }
      ]
      for (const { name, value } of offlineDefaults) {
        if (!vm.networkSettings[name]) {
          const fallback = { name, value, useSystemDefault: true }
          vm.networkSettings[name] = angular.copy(fallback)
          vm.originals[name] = angular.copy(fallback)
        }
        if (generalSettings && !generalSettings[name]) {
          generalSettings[name] = { name, value, useSystemDefault: false }
        }
      }
    })

  vm.changeSetting = function (param, changeVal = false) {
    const setting = vm.networkSettings[param]

    if (changeVal) {
      vm.networkSettings[param].value = setting.value
    } else {
      vm.networkSettings[param].useSystemDefault = setting.useSystemDefault
      setting.value = (setting.useSystemDefault ? generalSettings : vm.networkSettings)[param].value
    }
  }

  vm.changeUnlimited = function (params) {
    vm.networkSettings.UNLIMITED_SUBSCRIPTION_ENABLED.useSystemDefault = vm.networkSettings.ACTIVATION_LENGTH_LIMIT.useSystemDefault
    vm.changeSetting(params[0])
    vm.changeSetting(params[1])
  }

  vm.changeDisallowVoid = function () {
    if (!vm.paymentVoidEnabled) {
      vm.networkSettings.PAYMENT_VOID_HOURS.value = 0
    } else {
      vm.changeSetting('PAYMENT_VOID_HOURS')
    }
  }

  vm.changeDisallowVoidUseSystem = function (param) {
    vm.changeSetting(param)
    vm.paymentVoidEnabled = !!(vm.networkSettings[param].useSystemDefault ? generalSettings : vm.networkSettings)[param].value
  }

  /**
   * Update settings
   *
   * @memberof mwApp/settings.controller:AddPackageCtrl
   */
  vm.submit = function (form, chatSaving = false) {
    vm.setDisable()

    if (!vm.paymentVoidEnabled) {
      vm.networkSettings.PAYMENT_VOID_HOURS.value = 0
    }
    if (vm.networkSettings.UNLIMITED_SUBSCRIPTION_ENABLED.value) {
      vm.networkSettings.ACTIVATION_LENGTH_LIMIT.value = vm.originals.ACTIVATION_LENGTH_LIMIT.value
    }

    NetworkSetting.saveAll(vm.networkSettings, vm.originals, generalSettings, { network: pckg })
      .then(() => {
        prepareSettings()
        alertSvc.alert(`${chatSaving ? 'Chat' : 'Organization'} Settings updated`, 'success')
        form.$setPristine()
        vm.networkSettings = angular.copy(vm.networkSettings)
      })
      .finally(vm.unsetDisable)
  }

  /*******************************/
  /* === Activation Setting === */
  /******************************/

  vm.enableVerifyEmail = function (form) {
    return ['emailaddress', 'emailpassword', 'emailhost', 'emailport'].some(field => form[field].$dirty)
  }

  vm.verifyEmailUrl = `/nora/api/networks/${vm.pckg.id}/settings/mail/verify`

  vm.verifyEmail = function () {
    vm.verifyEmailSpinner = true

    $http.post(vm.verifyEmailUrl, {})
      .data()
      .then((resp) => resp.payload)
      .then(data => {
        vm.emailServerSettingsChecked = true
        vm.emailServerSettingsValid = data.result === 'OK'
        vm.emailServerSettingsMessage = data.message
      })
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
      .finally(() => {
        vm.verifyEmailSpinner = false
      })
  }

  vm.saveEmailSettings = function () {
    if (!vm.mailSettings.password) {
      vm.mailSettings.password = null
    }

    const urlEmailSettings = `/nora/api/networks/${vm.pckg.id}/settings/mail`
    return $http.put(urlEmailSettings, vm.mailSettings)
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
  }

  /**
   * Update settings
   *
   * @memberof mwApp/settings.controller:GeneralSettingsCtrl
   */
  vm.submitActivationSettings = function (form) {
    vm.setDisable()

    vm.emailServerSettingsChecked = false
    if (!vm.paymentVoidEnabled) {
      vm.networkSettings.PAYMENT_VOID_HOURS.value = 0
    }

    if (vm.PAYMENT_LENGTH_UNLIMITED && vm.networkSettings.UNLIMITED_SUBSCRIPTION_ENABLED.value) {
      vm.networkSettings.ACTIVATION_LENGTH_LIMIT.value = vm.originals.ACTIVATION_LENGTH_LIMIT.value
    }

    $q.all([
      vm.saveEmailSettings(),
      NetworkSetting.saveAll(vm.networkSettings, vm.originals, generalSettings, { network: pckg }),
      vm.inapp_error == null ? InappSettings.saveForNetwork(vm.inapp, vm.pckg.id) : $q.when(),
      vm.smsGatewayEnabled ? vm.saveSmsSettings() : $q.when(),
      vm.dcbSmsGatewayEnabled ? vm.saveDcbSmsSettings() : $q.when(),
      vm.pckg.multiorgEnabled ? vm.saveResetPasswordSettings() : $q.when()

    ])
      .then(() => {
        alertLiteSvc.alert('Activation Settings updated', 'success')
        form.$setPristine()
        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  // sms gateway settings
  /**
   * SMS provider settings
   */
  vm.smsGatewayEnabled = authSvc.hasEnabledFlag('SIGN_IN_BY_PHONE_ENABLED')
  vm.dcbSmsGatewayEnabled = authSvc.hasEnabledFlag('FEATURE_DCB_SMS_GATEWAY_ENABLED')

  vm.smsSettingsUrl = `/nora/api/networks/${vm.pckg.id}/settings/sms`
  vm.dcbSmsSettingsUrl = `/nora/api/networks/${vm.pckg.id}/settings/sms/dcb`

  vm.senderTypes = [
    { value: 'ABBRIVIATED', label: 'Abbriviated' },
    { value: 'INTERNATIONAL', label: 'International' },
    { value: 'SENDER_NAME', label: 'Sender Name' }
  ]

  vm.saveSmsSettings = function () {
    if (vm.smsSettings.authId && !vm.smsSettings.smsProviderType) { vm.smsSettings.smsProviderType = 'PLIVO' }
    if (!vm.smsSettings.authId && !vm.smsSettings.fromPhone) { vm.smsSettings.smsProviderType = null }
    return $http.put(vm.smsSettingsUrl, vm.smsSettings)
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
  }

  vm.saveDcbSmsSettings = function () {
    if (vm.dcbSmsSettings.enabled && !vm.dcbSmsSettings.smsProviderType) { vm.dcbSmsSettings.smsProviderType = 'TRUE_SMS_GW' }
    if (!vm.dcbSmsSettings.enabled) vm.dcbSmsSettings.smsProviderType = null
    return $http.put(vm.dcbSmsSettingsUrl, { ...vm.dcbSmsSettings, senderType: vm.dcbSmsSettings.senderType?.value })
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
  }

  vm.saveResetPasswordSettings = function () {
    return $http.post(`/nora/api/networks/${vm.pckg.id}/settings/login-options/reset-password`, { resetPasswordEnabled: !!vm.inapp?.resetPasswordSettings?.resetPasswordEnabled })
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
  }

  /***********************************/
  /* === Get Activation settings === */
  /***********************************/
  if (vm.pckg.id && vm.pckg.multiorgEnabled) {
    Network.getLoginOptionsSubscriptions(pckg.id).then((res) => {
      vm.subscriptions = res
    })

    Network.getLoginOptions(vm.pckg.id).then(res => {
      vm.inapp = res
    })

    const urlEmailSettings = `/nora/api/networks/${vm.pckg.id}/settings/mail`
    $http.get(urlEmailSettings)
      .data()
      .then((resp) => {
        vm.mailSettings = resp.payload
      })
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))

    vm.smsGatewayEnabled && $http.get(vm.smsSettingsUrl)
      .data()
      .then((resp) => resp.payload)
      .to(vm.smsSettings = {})
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))

    vm.dcbSmsGatewayEnabled && $http.get(vm.dcbSmsSettingsUrl)
      .data()
      .then((resp) => {
        vm.passwordRequired = !resp.payload.authId
        return { ...resp.payload, enabled: !!resp.payload.smsProviderType, senderType: vm.senderTypes.find(type => type.value === resp.payload.senderType) }
      })
      .to(vm.dcbSmsSettings = {})
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
  } else {
    vm.inapp = {}
  }

  vm.storedPassword = null

  vm.viewPassword = function () {
    vm.passVisible = !vm.passVisible

    if (vm.passVisible) {
      if (vm.storedPassword !== null) {
        vm.mailSettings.password = vm.storedPassword
      } else {
        $http.get(`/nora/api/networks/${pckg.id}/settings/mail/pass`)
          .data()
          .then((resp) => resp.payload)
          .then(data => {
            vm.mailSettings.password = vm.storedPassword = data.password
          })
          .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
      }
    }
  }

  vm.copyString = function (model, text = '') {
    navigator.clipboard.writeText(model)
    alertLiteSvc.alert('Copied ' + text, 'success')
  }

  vm.submitTemplateForm = function () {
    vm.setDisable()

    TemplateVariable.saveTemplatesByEntity(vm.templateVariables, vm.pckg.id)
      .then(() => {
        alertLiteSvc.alert('Template variable values saved successfully', 'success')
        vm.location.reload()
      })
      .catch(() => { alertLiteSvc.alertError('Failed to save template variable values') })
      .finally(vm.unsetDisable)
  }

  /*
  * change Use system default for template variable
  * */
  vm.changeUsdTv = function (tv) {
    if (!tv.useDefaultValue) return

    tv.value = null
  }
}
